import * as React from "react"
const RoundTick = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={19}
    height={19}
    fill="none"
    {...props}
  >
    <g
      stroke={props.color?"#12DD7B":"#000"}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      clipPath="url(#a)"
    >
      <path d="M16.941 9.007v.69a7.5 7.5 0 1 1-4.447-6.855" />
      <path d="m16.941 3.696-7.5 7.508-2.25-2.25" />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M.441.696h18v18h-18z" />
      </clipPath>
    </defs>
  </svg>
)
export default RoundTick
